export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white text-center p-6">
      <p>Mecânica Pichinin © {new Date().getFullYear()}</p>
      <p>R. Herminio Mantelli, 280 - Jardim Santa Rosa, Jaú - SP, 17209-560</p>
      <a
        href="https://www.google.com/maps/place/Bosch+Car+Service+-+Mecânica+Pichinin+Jaú/@-22.2733609,-48.5455224,17z/data=!3m1!4b1!4m6!3m5!1s0x94c75800641ec3eb:0xa00f155aa31fb213!8m2!3d-22.2733659!4d-48.5429475!16s%2Fg%2F1wn_763j?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Ver no Google Maps
      </a>
    </footer>
  );
}
